import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Button } from "react-bootstrap";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import React from "react";

export const NavBar = () => {
  const [activeKey, setActiveKey] = useState("/");

  const location = useLocation();
  React.useEffect(() => {
    // runs on location, i.e. route, change
    // console.log("handle route change here", location);
    setActiveKey(location.pathname);
  }, [location]);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "auto",
    });
  };

  return (
    <Navbar expand="lg" variant="dark">
      {/* <Navbar collapseOnSelect bg="dark" variant='dark' expand="lg"></Navbar> */}
      <Container>
        {/* <Navbar.Brand href="/">Home</Navbar.Brand> */}
        {/* The below adds the toggle on the right to show the drop down when screen is small */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav
            activeKey={activeKey}
            onSelect={(key, event) => setActiveKey(key as string)}
            // className="m-auto"
            className="justify-content-center" // Use this along with flex: 1 to center in the middle
            variant="underline"
            style={{
              flex: 1,
              alignItems: "baseline" /* Vertically center items */,
            }}
          >
            {/* Using href causes full page reload. Using 'as' with 'to' does not refresh the page */}
            <Nav.Link as={Link} to="/" eventKey="/" style={{ fontSize: 30 }}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/aboutme" eventKey="/aboutme">
              About Me
            </Nav.Link>
            <Nav.Link as={Link} to="/research" eventKey="/research">
              Research
            </Nav.Link>
            <Nav.Link as={Link} to="/teaching" eventKey="/teaching">
              Teaching
            </Nav.Link>
            <Nav.Link as={Link} to="/developments" eventKey="/developments">
              Developments
            </Nav.Link>
            <Nav.Link as={Link} to="/awards" eventKey="/awards">
              Awards
            </Nav.Link>
            <Nav.Link as={Link} to="/photogallery" eventKey="/photogallery">
              Photo Gallery
            </Nav.Link>
            <Button variant="outline-light" onClick={scrollToBottom}>
              Contact
            </Button>

          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
